import axiosInstance from '@/shared/api/axios';
import type {
  ApiLegacyClientItem,
  ApiLegacyClientsListParams,
  ApiLegacyClientsListResponse,
} from '@/shared/types/api/legacy-clients';

export const apiLegacyClientsList = async (
  params: ApiLegacyClientsListParams,
): Promise<ApiLegacyClientsListResponse> => {
  const { data } = await axiosInstance.get<ApiLegacyClientsListResponse>(
    '/legacy-clients',
    { params },
  );
  return data;
};

export const apiLegacyClientGet = async (id: string | number): Promise<ApiLegacyClientItem> => {
  const { data } = await axiosInstance.get<ApiLegacyClientItem>(`/legacy-clients/${id}`);
  return data;
};
